import React, { useState } from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    formatStaffAttendanceDate,
    formatStaffAttendanceDuration,
} from "../helpers/staff-attendance-api-helper";
import StaffAttendanceWorkerRowField from "./staff-attendance-worker-row-field";


const StaffAttendanceGroupField = ({ group, groupBy, onOpenLocation }) => {
    const [ expanded, setExpanded ] = useState(Boolean(group.initially_expanded));
    const [ expandedWorkerID, setExpandedWorkerID ] = useState();
    const groupTitleID = `staff-attendance-group-title-${ group.id }`;
    const groupRowsID = `staff-attendance-group-rows-${ group.id }`;
    const title = groupBy === "subcontractor" ?
        group.subcontractor?.title :
        formatStaffAttendanceDate(group.date);

    return (
        <section className={ `staff-attendance-group${ expanded ? " staff-attendance-group--expanded" : "" }` }>
            <button
                type="button"
                className="d-flex align-items-center w-100 cursor-pointer staff-attendance-group__header"
                aria-expanded={ expanded }
                aria-controls={ groupRowsID }
                onClick={ () => setExpanded((value) => !value) }>
                <Icons.Arrow className="staff-attendance-group__toggle" />
                <strong id={ groupTitleID }>{ title || <>&mdash;</> }</strong>
                <span className="staff-attendance-group__summary">
                    <strong>
                        { group.workers_count === 1 ?
                            <Localize>STAFF_MANAGEMENT.Text_OneWorker</Localize> :
                            <Localize count={ group.workers_count }>STAFF_MANAGEMENT.Text_WorkersCount</Localize>
                        }
                    </strong>
                    <span className="staff-attendance-group__summary__total-worked-seconds">
                         <span aria-hidden="true"> | </span>
                        { formatStaffAttendanceDuration(group.total_worked_seconds) }
                    </span>
                </span>
            </button>

            { expanded &&
                <div
                    id={ groupRowsID }
                    role="table"
                    aria-labelledby={ groupTitleID }>
                    <div className="visually-hidden" role="row">
                        <span role="columnheader" />
                        <span role="columnheader"><Localize>STAFF_MANAGEMENT.Column_Worker</Localize></span>
                        <span role="columnheader">
                            { groupBy === "subcontractor" ?
                                <Localize>STAFF_MANAGEMENT.Column_Date</Localize> :
                                <Localize>STAFF_MANAGEMENT.Column_Subcontractor</Localize>
                            }
                        </span>
                        <span role="columnheader"><Localize>STAFF_MANAGEMENT.Column_FirstCheckIn</Localize></span>
                        <span role="columnheader"><Localize>STAFF_MANAGEMENT.Column_LastCheckOut</Localize></span>
                        <span role="columnheader"><Localize>STAFF_MANAGEMENT.Column_TotalHours</Localize></span>
                        <span role="columnheader" />
                    </div>

                    { group.workers.map((attendanceRow) => (
                        <StaffAttendanceWorkerRowField
                            key={ attendanceRow.id }
                            attendanceRow={ attendanceRow }
                            groupBy={ groupBy }
                            expanded={ expandedWorkerID === attendanceRow.id }
                            onToggle={ () => setExpandedWorkerID((workerID) => (
                                workerID === attendanceRow.id ? undefined : attendanceRow.id
                            )) }
                            onOpenLocation={ onOpenLocation } />
                    )) }
                </div>
            }
        </section>
    );
};

export default StaffAttendanceGroupField;
